import React, { useEffect, useState } from "react";
import Card from "components/card";
import { User } from "lucide-react";
import { 
    getUserProfile
} from "../../../../redux/auth/authState";
import { connect, useDispatch, useSelector } from "react-redux";
import MyAvatar from "./MyAvatar";


const MyProfile = ({
    ...props
}) => {
    const [employee, setEmployee] = useState(null);
    const recordData = useSelector((state) => state.auth.userProfile?.data);
    const fullName = recordData?.full_name;
    const record = recordData?.employee;

    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth.user);

    const getDetails = (data) => dispatch(getUserProfile(data));

    useEffect(() => {
        if (recordData) {
            setEmployee(recordData);
        }
    }, [recordData]);

    useEffect(() => {
        if (!recordData && user) {
            getDetails(user.id);
        }
    }, [getDetails, user]);

    return (
        <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-xl border border-slate-200 dark-mode-card">
            <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 [.border-b]:pb-6"> 
                <h4 className="leading-none flex items-center gap-2 title-text">
                    <User className="w-5 h-5 text-emerald-600" />
                    My Profile
                </h4>
                <p className="muted-text">
                    View and update your personal information
                </p>
            </div>
            <div className="px-6 pb-6">
                <div className="space-y-6">
                    <div className="flex items-center gap-6">
                        <MyAvatar 
                            initials={recordData?.profile_initials}
                            avatarClassName="h-24 w-24 border-4 border-emerald-200 text-2xl"
                        />
                        <div>
                            <h3 className="text-xl font-semibold title-text">
                                {fullName}
                            </h3>
                            <p className="muted-text">
                                {record?.emp_title}
                            </p>
                            <span className="inline-flex items-center justify-center rounded-lg border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 gap-1 transition-[color,box-shadow] overflow-hidden border-transparent mt-2 bg-emerald-100 text-emerald-700 dark:bg-emerald-800 dark:text-emerald-100">
                                {record?.emp_code}
                            </span>
                        </div>
                    </div>
                    <div className="bg-border shrink-0 h-px w-full"></div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="text-sm font-medium muted-text">Email</label>
                            <p className="text-sm mt-1 title-text">{recordData?.user?.email}</p>
                        </div>
                        <div>
                            <label className="text-sm font-medium muted-text">Department</label>
                            <p className="text-sm mt-1 title-text">
                                {record?.department_name}
                            </p>
                        </div>
                        <div>
                            <label className="text-sm font-medium muted-text">Location</label>
                            <p className="text-sm mt-1 title-text">{recordData?.country_name}</p>
                        </div>
                        
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default MyProfile;